<template>
    <div>
        <!-- <el-card v-if="id && formData" shadow="never" class="MT20">
            <ul>
                <li><span class="color-info">实际打款金额: </span>{{formData.playPriceTicketFormat}}</li>
                <li class="MT10"><span class="color-info">打款流水号: </span>{{formData.playPriceNo}}</li>
                <li class="MT10"><span class="color-info">打款时间: </span>{{formData.playTime}}</li>
                <li class="MT10"><span class="color-info">结款信息提交人: </span>{{formData.playUserName}}</li>
            </ul>
        </el-card> -->
        <el-form
            v-if="formData"
            :model="formData"
            ref="formData"
            label-position="top"
        >
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="playPriceTicketFormat" label="实际打款金额:" :rules="[{required:true,message:'请填写打款金额'}]">
                        <el-input-number style="width:100%" v-model="formData.playPriceTicketFormat" :precision="2" controls-position="right" :min="0.00" :max="99999999.99" size="medium" placeholder="请填写打款金额" :disabled="formData.status == 2"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="playPriceNo" label="打款流水号:" :rules="[{required:true,message:'请填写打款流水号'}]">
                        <el-input v-model="formData.playPriceNo" maxlength="50" size="medium" placeholder="请填写打款流水号" :disabled="formData.status == 2"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="playTime" label="打款时间:" :rules="[{required:true,message:'请填写打款时间'}]">
                        <el-date-picker v-model="formData.playTime"  type="datetime" size="medium" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formData.status == 2"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col v-if="formData.status == 2" :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="playUserName" label="结款信息提交人:">
                        <el-input v-model="formData.playUserName" disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="playPic">
                        <span slot="label">打款截图: <small>支持格式为JPG、PNG,不大于10M,最多上传3张</small></span>   
                        <div>
                            <el-upload
                                action
                                list-type="picture-card"
                                accept="image/png,image/jpeg"
                                :file-list="formData.fileList"
                                :http-request="uploadImage"
                                :on-remove="handleRemove"
                                :before-upload="beforeUpload"
                                :disabled="uploadLoading"
                                :limit="3"
                                :on-exceed="handleExceed">
                                <el-progress v-if="progress && progress < 100" :width="120" type="circle" :percentage="progress"></el-progress>
                                <i v-else class="el-icon-plus"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="playDesc" label="打款备注:">
                        <el-input v-model="formData.playDesc" type="textarea" :rows="2" maxlength="100" show-word-limit placeholder="请填写打款备注"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import {uploadImg} from '@/assets/js/commonApi.js';
const defaultFormData = {
    playDesc:'',
    playPriceNo:'',
    playPic:[],
    playPriceTicket:'',
    playPriceTicketFormat: undefined,
    playTime:'',
    fileList: []
}
export default {
    props:{
        id:{
            type: [Number,String],
            default: ''
        },
        btnLoading: {
            type: Boolean,
            default: false
        },
        // applyEndTime:{
        //     type: String,
        //     default: ""
        // },
        // playInfo:{
        //     type: Object,
        //     default: null
        // }
    },
    data(){
        return{
            uploadLoading: false,
            progress:null,
            dataLoading: false,
            formData:{ ...defaultFormData }
        }
    },
    created(){
        if(this.id){
            this.getData()
        }
    },
    methods:{
        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/goodsReceivablesAudit/audi/get',
                params: {id: this.id},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData = result ? {
                            ...this.formData,
                            ...result, 
                            playPic: result.playPicList || [], 
                            fileList: result.playPicList.map( v => {return {url: v}}),
                            playPriceTicketFormat: result.playPriceTicketFormat || undefined
                        } : {...this.formData};
                    } else {
                        this.$message.error(msg || "获取结款信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取结款信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        handleExceed() {
            this.$message.warning('最多上传3张图片');
        },
        handleRemove(file, fileList) {
            const _index = this.formData.fileList.findIndex(v => v === file);

            this.formData.playPic = this.formData.playPic.filter( (v,i) => i !== _index);

            this.formData.fileList = fileList; 
        },
        beforeUpload(file){
            this.formData.fileList = this.formData.fileList.filter( v => v !== file)
        },
        async uploadImage(req){
            const {
                file,
                file: { type, size },
            } = req;

            //格式检查
            const formatVerified =
                type === "image/jpeg" || file.type === "image/png";
            if (!formatVerified) {
                this.$message.error("图片格式错误,请重新上传");
                return;
            }
            //大小检查
            const bytesVerified = size / 1024 / 1024 < 10;
            if (!bytesVerified) {
                this.$message.error("图片尺寸错误,请重新上传");
                return;
            }

            // 上传图片
            const formData = new FormData();
            formData.append("file", file);
             
            this.uploadLoading = true;
            const res = await uploadImg(formData,ev => {
                this.progress = Math.floor((ev.loaded / ev.total) * 100);
            }).finally(() => {
                this.uploadLoading = false;
            });

            const {state,result,msg} = res.data;
            if(state == 1){
                this.formData.fileList.push({
                    url:result.urlFull
                });
                this.formData.playPic.push(result.url);
            }else{
                this.$message.error( msg || '上传失败');
            }
        },
        onSubmit(callback){
            if(this.$refs.formData) {
                // if(!this.id && !this.applyEndTime){
                //     return this.$message.error('请填写销售截止时间');
                // }
                this.$refs["formData"].validate((valid) => {
                    if (valid) {
                        // const _confirmMsg = this.formData.id ? '确定提交结款信息？' : '确定创建结款单？结款单创建成功后，会锁定关联订单，付款前这些订单態取消和二次申请结算。';
                        this.$confirm('确定提交结款信息？', '提示', {
                            type: 'warning',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$emit('update:btnLoading', true) ;

                            let _url = '/goodsReceivablesAudit/audi/audi';

                            // if( !this.formData.id ){ //新增
                            //     _url = '/goodsReceivablesAudit/audi/createAudi';
                            //     this.formData = {
                            //         ...this.formData,
                            //         applyEndTime: this.applyEndTime,
                            //         applyUserId: this.playInfo.applyUserId,
                            //         playInfo:{
                            //             ...this.playInfo,
                            //             totalAmount: this.playInfo.saleAmountFormat,
                            //             totalSell: this.playInfo.saleNum,
                            //             totalSubsidyAmount: parseFloat(this.playInfo.busDiscountFormat) + parseFloat(this.playInfo.platDiscountFormat),
                            //             userSubsidyAmount: this.playInfo.busDiscountFormat,
                            //             serviceFeeAmount: this.playInfo.serviceFeeAmountFormat,
                            //             proposeAmount:  this.playInfo.proposeAmountFormat,
                            //         },
                            //         playPriceTicket:this.formData.playPriceTicketFormat
                            //     }
                            // }
                            this.$request({
                                url: _url,
                                data: this.formData,
                                method: "post",
                            })
                                .then((res) => {
                                    const { state, msg } = res.data;
                                    if (state == 1) {
                                        this.formData = {...defaultFormData};
                                        this.$refs.formData.resetFields();
                                        if(callback) callback(res);
                                    } else {
                                        this.$message.error(msg || "操作失败,请重试");
                                    }
                                })
                                .catch(() => {
                                    this.$message.error("操作失败,请重试");
                                })
                                .finally(() => {
                                    this.$emit('update:btnLoading', false) ;
                                });
                        }).catch(() => {})    
                    } else {
                        return false;
                    }
                });
            }else{
                if(callback) callback();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.info-table{
    .el-image{
        width: 60px;
        height: 60px;
        margin-right: 5px;
    }
}
.el-card{
    margin-bottom: 20px;
}
</style>